import { LodashExtractor, StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';

export const PC_FIXED_INCOME_FACTS: { [factName: string]: FactMappingInterface } = {
	numberOfFIFunds: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.assetClass === 'Fixed Income' && child.assetType === 'ASSET_TYPE_FUND').length;
		})
	},

	fixedIncomePercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.portfolioBreakdowns',
				[
					{ propertyToCompare: 'name', comparedValue: 'assetClass', desiredValueExpression: 'sectors' }
				]
			)], sectors => {
			return (sectors.find(child => child.name === 'Fixed Income')?.contribution || 0) * 100;
		})
	},

	rateRisk: {
		extractor: new FactExtractor([new LodashExtractor('risk.risk.factorContributors')], factorContributors => {
			return calculateRiskPercentage(factorContributors, 'Rates', 'Spreads');
		})
	},

	creditSpreadRisk: {
		extractor: new FactExtractor([new LodashExtractor('risk.risk.factorContributors')], factorContributors => {
			return calculateRiskPercentage(factorContributors, 'Spreads', 'Rates');
		})
	},

	creditSpreadRiskAsPercentageOfTotalRisk: {
		extractor: new FactExtractor(
			[
				new LodashExtractor('risk.risk.factorContributors'),
				new LodashExtractor('risk.risk.total')
			], (factorContributors, totalRisk) => {
				const creditSpreadRisk = factorContributors.find(fc => fc.name === 'Spreads')?.contribution || 0;
				return (creditSpreadRisk / totalRisk) * 100;
			})
	},


	fiSleeveTotalRisk: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['risk'],
				'risk.sleeves',
				[{ propertyToCompare: 'sleeveId', comparedValue: 'fixedIncome', desiredValueExpression: 'sleeveAnalysis.risk.total' }]
			)
		], totalRisk => {
			return (totalRisk || 0) * 100;
		})
	},

	fiRelativeRateRisk: {
		extractor: new FactExtractor(
			[
				new LodashExtractor('risk.risk.factorContributors'),
				new StoreNestedFilterExtractor(
					['risk'],
					'risk.sleeves',
					[{ propertyToCompare: 'sleeveId', comparedValue: 'fixedIncome', desiredValueExpression: 'sleeveAnalysis.risk.total' }]
				)
			], (factorContributors, totalRisk) => {
				const rateRisk = calculateRiskPercentage(factorContributors, 'Rates', 'Spreads');
				return rateRisk / totalRisk;
			})
	},

	fiRelativeCreditSpreadRisk: {
		extractor: new FactExtractor(
			[
				new LodashExtractor('risk.risk.factorContributors'),
				new StoreNestedFilterExtractor(
					['risk'],
					'risk.sleeves',
					[{ propertyToCompare: 'sleeveId', comparedValue: 'fixedIncome', desiredValueExpression: 'sleeveAnalysis.risk.total' }]
				)
			], (factorContributors, totalRisk) => {
				const spreadRisk = calculateRiskPercentage(factorContributors, 'Spreads', 'Rates');
				return spreadRisk / totalRisk;
			})
	}
};

function calculateRiskPercentage(factorContributors: any, first: string, second: string): number {
	const firstRisk = factorContributors.find(fc => fc.name === first)?.contribution || 0;
	const secondRisk = factorContributors.find(fc => fc.name === second)?.contribution || 0;
	const riskTotal = firstRisk + secondRisk;
	return (firstRisk / riskTotal) * 100;
}
